<template>
  <div class="personCenter">
    <div class="personal-box comWidth">
    <CenterNav/>
    <div class="personal-right">
      <NavT :titleS="titleS"/>
      <div class="rightmain">
        <div class="right-persinalIndex">
          <div class="title">
            <h5 v-if="signInInformation.is_validated == 0"><span>您好！尊敬的極草用戶</span>  歡迎您回到澳門極草線上商城！</h5>
            <h5 v-if="signInInformation.is_validated == 1"><span>您好！{{signInInformation.real_name.slice(0,1)}}<span v-if="signInInformation.sex == 0">先生/女士</span><span v-if="signInInformation.sex == 1">先生</span><span  v-if="signInInformation.sex == 2">女士</span></span>  歡迎您回到澳門極草線上商城！</h5>
            <p>您上一次登錄的時間：{{signInInformation.last_time}}</p>
          </div>
          <div class="word-mian">
            <div class="personal-form">
              <div class="title">
                <span>個人資料</span>
                <div class="fr">
                  <button class="xiugai" @click="xiugai" v-if="xiuState"> 修改 </button>
                  <button class="baocun" v-if="baoState" @click="baocun">保存</button>
                </div>
              </div>
              <div class="input-box">
                <table class="table">
                  <tr>
                    <td>
                      <label >
                        <span>移動電話</span>
                        <input type="tel" readonly="readonly" v-model="signInInformation.phone" >
                      </label>
                    </td>
                    <td>
                     <label>
                       <span>電子郵箱</span>
                       <input readonly="readonly" type="email" v-model="signInInformation.email">
                     </label>
                   </td>
                    <td>
                      <label >
                        <span>姓名</span>
                        <input  readonly="readonly" type="text" v-model="signInInformation.real_name">
                      </label>
                    </td>
         <!--           <td>
                      <label >
                        <span>名</span>
                        <input
                          :disabled="disabled"
                          type="text"
                          :class="{ba:showState}"
                          v-model="formUser.name">
                      </label>
                    </td>-->
                  </tr>
                  <tr>
                    <td>
                      <label >
                        <!--<input class="datainp wicon" id="date03" type="text" placeholder="YYYY-MM-DD"  readonly>-->
                        <span>出生日期</span>
                        <!--<input class="datainp wicon" :class="{ba:showState}" :disabled="disabled" type="text" name="birthday" value="2018-04-20" readonly>-->
                        <el-date-picker
                          v-model="formUser.birthday"
                          type="date"
                          placeholder="選擇日期"
                          format="yyyy 年 MM 月 dd 日"
                          :disabled="disabled"
                          value-format="yyyy-MM-dd">
                        </el-date-picker>
                      </label>
                    </td>
                    <td>
                      <label >
                        <span>性別</span>
                        <select :disabled="disabled"
                                v-model="formUser.sex"
                                :class="{ba:showState}">
                          <option value="1" >男</option>
                          <option value="2" >女</option>
                          <option value="0"   selected="selected">保密</option>
                        </select>
                      </label>
                    </td>
                <!--    <td>
                      <label>
                        <span>電子郵箱</span>
                        <input readonly="readonly" type="text" name="email" value="">
                      </label>
                    </td>-->
                  </tr>
           <!--       <tr>
                    <td>
                      <label >
                        <span>移動電話</span>
                        <input
                          :class="{ba:showState}"
                          :disabled="disabled"
                          type="tel"
                          v-model="formUser.phone"
                          name="phone" >
                      </label>
                    </td>
                  </tr>-->
                </table>
              </div>
              <input name="act" type="hidden" value="act_edit_profile" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  //nav
  import NavT from '@/pages/personalPage/NavT'
  //cNav
  import CenterNav from '@/pages/personalPage/CenterNav'
  //api
  import {userInformation,personalData} from '@/api/authentication';
  export default {
    name: 'PersonCenter',
    components:{
      NavT,
      CenterNav
    },
    data () {
      return {
        titleS:'個人中心',
        xiuState:true,
        baoState:false,
        //状态禁用
        disabled:true,
        showState:false,
        birthday: '',
        /*修改个人资料*/
        formUser:{
          birthday:'',//生日
          sex:'',//性别
        },
        /*登陆后的用户信息*/
        signInInformation:{}

      }
    },
    methods:{
        /*修改*/
      xiugai(){
          this.xiuState = false;
          this.baoState = true;
          this.disabled = false;
          this.showState = true;
      } ,

      /*保存*/
      baocun(){
          if(!this.formUser.birthday){
            this.$message.error('請選擇出生日期');
          }else {
            personalData(this.formUser).then(res =>{
              this.xiuState = true;
              this.baoState = false;
              this.disabled = true;
              this.showState = false;
              this.$message.success('修改成功');
              this.getInformation();
            })
          }
      },

      /*获取登陆后的个人信息*/
      getInformation(){
        userInformation().then(res =>{
            this.signInInformation = res.data;
            this.formUser.sex = this.signInInformation.sex;
            this.formUser.birthday = this.signInInformation.birthday;
        })
      }
    },
    created(){
      //登陆后的个人信息
      this.getInformation();
      window.scrollTo(0,0)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.personCenter{
  .title{
    margin-bottom: 50px;
    h5{
      font-size: 16px;
      span{
        color: #e63350;
        font-weight: bold;
        font-size: 16px;
      }
    }
    p{
      color: #909090;
      margin-top: 12px;
      display: block;
    }
  }
.word-mian{
  background-color: #fafafa;
  padding: 38px 0;
    .title{
      font-size: 16px;
      color: #000;
      font-weight: bold;
      padding: 0 42px;
      display: flex;
      justify-content: space-between;
      .xiugai{
        display: block;
        font-size: 14px;
        color: #0072b9;
        font-weight: normal;
        width: 50px;
        height: 30px;
        background: none;
      }
      button{
        width: 50px;
        height: 30px;
        background-color: #0072b9;
        color: #fff;
        font-weight: normal;
        cursor: pointer;
      }
    }
  }

  .input-box{
    .table{
      margin-top: 20px;
      text-align: center;
      width: 100%;
      max-width: 100%;
      margin-bottom: 20px;
      tr{
        td{
          border-top: none;
          label{
            display: inline-block;
            max-width: 100%;
            margin-bottom: 5px;
            font-weight: normal;
            text-align: left;
            color: #535353;
            span{
              display: inline-block;
              width: 60px;
            }
            input,select{
              border: 1px solid #eee;
              width: 194px;
              height: 38px;
              text-indent: 1em;
            }
          }
        }
      }
    }
  }
  .ba{
    background: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/personalPage/PersonCenter.vue